import StarRating from '@theme/components/utils/StarRating'

export default {
  name: 'UserReviewBox',
  components: { StarRating },
  props: {
    author: String,
    description: String,
    rating: Number,
  },
}
